import { useHits, useInstantSearch } from 'react-instantsearch';

import { Sport } from '@sorare/core/src/__generated__/globalTypes';

import { CommonPlayerPreview } from '#src/components/commonCard/CommonPlayerPreview/index.tsx';
import {
  GridOverlayLoadingIndicator,
  MarketGrid,
} from '#src/components/market/Grid/index.tsx';
import type { CardResultsProps } from '#src/searchCards/AdvancedCardSearch/types.ts';

import type { CommonCardsGrid_commonPlayer } from './__generated__/types.graphql.ts';

export const CommonCardsGrid = ({
  onStatsClick,
  sport,
}: CardResultsProps & {
  onStatsClick: (playerSlug: string) => void;
}) => {
  const { status } = useInstantSearch();
  const { items } = useHits<CommonCardsGrid_commonPlayer>();

  if (sport === Sport.FOOTBALL) return null;

  const loading = status === 'loading' || status === 'stalled';

  return (
    <>
      <MarketGrid>
        {items.map((commonPlayer, index) => {
          return (
            <CommonPlayerPreview
              key={commonPlayer.id}
              commonPlayer={commonPlayer}
              onStatsClick={() => onStatsClick(commonPlayer.anyPlayer.slug)}
              showPlayerCostHighlight={index === 0}
            />
          );
        })}
      </MarketGrid>
      {!!loading && <GridOverlayLoadingIndicator />}
    </>
  );
};
